import React, { useState, useEffect, useCallback } from 'react';

const BASE_URL = 'https://api.pixventa.com';

const PAQUETERIAS = {
  dhl:      'DHL',
  fedex:    'FedEx',
  estafeta: 'Estafeta',
  jt:       'J&T Express',
  '99min':  '99Minutos',
  redpack:  'Redpack',
  ups:      'UPS',
  amazon:   'Amazon Logistics',
};

const TRACKING = {
  dhl:      'https://www.dhl.com/mx-es/home/tracking.html?tracking-id=',
  fedex:    'https://www.fedex.com/fedextrack/?trknbr=',
  estafeta: 'https://www.estafeta.com/herramientas/rastreo?wayBill=',
  jt:       'https://www.jtexpress.mx/index/query/gzquery.html?bills=',
  '99min':  'https://www.99minutos.com/rastreo?guia=',
  redpack:  'https://www.redpack.com.mx/es/rastreo/?ids=',
  ups:      'https://www.ups.com/track?tracknum=',
  amazon:   'https://track.amazon.com.mx/tracking/',
};

const MOTIVOS_CANCELACION = [
  'El cliente cambió de opinión',
  'Ya no lo quiere el cliente',
  'Producto sin stock',
  'Talla/color incorrecto',
  'Error en el pedido',
  'Precio incorrecto',
  'Dirección incorrecta',
  'Tiempo de entrega muy largo',
  'Problema con el pago',
  'Duplicado accidentalmente',
];

const PILL = {
  pendiente:  { bg: '#fff8e1', color: '#f57f17', texto: 'Pendiente' },
  confirmado: { bg: '#e3f2fd', color: '#1565c0', texto: 'Confirmado' },
  enviado:    { bg: '#e8f5e9', color: '#2e7d32', texto: 'Enviado' },
  espera:     { bg: '#fff3e0', color: '#e65100', texto: 'En espera del cliente' },
  recogido:   { bg: '#e8f5e9', color: '#1b5e20', texto: 'Recogido' },
  revision:   { bg: '#fce4ec', color: '#880e4f', texto: 'En revisión' },
  cancelado:  { bg: '#ffebee', color: '#c62828', texto: 'Cancelado' },
  entregado:  { bg: '#e8f5e9', color: '#1b5e20', texto: 'Entregado' },
};

const FILTROS = ['todos','pendiente','confirmado','enviado','revision','espera','recogido','cancelado','entregado'];

function iniciales(nombre) {
  return (nombre || '').split(' ').slice(0, 2).map(x => x[0]).join('').toUpperCase();
}

function parseJSON(val) {
  if (!val) return [];
  if (typeof val === 'object') return val;
  try { return JSON.parse(val); } catch { return []; }
}

function ItemsList({ items }) {
  const parsed = parseJSON(items);
  if (!parsed.length) return <div style={S.emptyItems}>Sin productos</div>;
  return (
    <div style={S.itemsWrap}>
      {parsed.map((item, i) => (
        <div key={i} style={{ ...S.itemRow, borderBottom: i < parsed.length - 1 ? '1px solid #E4EDE8' : 'none' }}>
          <div style={S.itemEmoji}>{item.emoji || '📦'}</div>
          <div style={S.itemInfo}>
            <div style={S.itemNombre}>{item.nombre}</div>
            <div style={S.varRow}>
              <span style={S.colorChip}>{item.color}</span>
              {item.talla && item.talla !== item.color && (
                <span style={S.tallaChip}>{item.talla}</span>
              )}
            </div>
          </div>
          <div style={S.qtyWrap}>
            <span style={S.qtyLbl}>Piezas</span>
            <span style={S.qty}>x{item.cantidad || item.qty || 1}</span>
          </div>
        </div>
      ))}
    </div>
  );
}

function ConfirmWA({ nombre, tel, msg, onCerrar }) {
  function enviar() {
    const num = (tel || '').replace(/\D/g, '');
    window.open(`https://wa.me/${num}?text=${encodeURIComponent(msg)}`, '_blank');
    onCerrar();
  }
  return (
    <div style={S.confirmOverlay}>
      <div style={S.confirmCard}>
        <div style={S.confirmTitle}>💬 Notificar al cliente</div>
        <div style={S.confirmMsg}>Para: {nombre} ({tel}){'\n\n'}{msg}</div>
        <div style={S.confirmBtns}>
          <button style={S.confirmNo} onClick={onCerrar}>Ahora no</button>
          <button style={S.confirmSi} onClick={enviar}>📲 Enviar por WhatsApp</button>
        </div>
      </div>
    </div>
  );
}

function ModalCancelacion({ pedido, onCerrar, onConfirmar }) {
  const [motivo,      setMotivo]      = useState('');
  const [comentarios, setComentarios] = useState('');

  function confirmar() {
    if (!motivo) { alert('Selecciona un motivo de cancelación'); return; }
    onConfirmar(motivo, comentarios);
  }

  return (
    <div style={S.overlay} onClick={e => e.target === e.currentTarget && onCerrar()}>
      <div style={S.modal}>
        <div style={S.handle} />
        <div style={{ ...S.modalHdr, borderColor: '#ffcdd2' }}>
          <span style={{ ...S.modalTitle, color: '#c62828' }}>⚠️ Cancelar pedido #{pedido.numero}</span>
          <button style={S.closeBtn} onClick={onCerrar}>✕</button>
        </div>
        <div style={S.modalBody}>
          <div style={S.avisoRojo}>
            ⚠️ Esta acción no se puede deshacer. El pedido quedará cancelado y se notificará al cliente por WhatsApp.
          </div>
          <div style={S.msec}>
            <div style={S.mlbl}>Motivo de cancelación</div>
            <select style={S.select} value={motivo} onChange={e => setMotivo(e.target.value)}>
              <option value="">Selecciona un motivo...</option>
              {MOTIVOS_CANCELACION.map(m => <option key={m} value={m}>{m}</option>)}
            </select>
          </div>
          <div style={S.msec}>
            <div style={S.mlbl}>
              Comentarios adicionales{' '}
              <span style={{ color: '#7A8F89', fontWeight: 400, textTransform: 'none' }}>(opcional)</span>
            </div>
            <textarea
              style={S.textarea}
              placeholder="Escribe cualquier detalle adicional sobre la cancelación..."
              value={comentarios}
              onChange={e => setComentarios(e.target.value)}
            />
          </div>
          <div style={{ display: 'flex', gap: 8 }}>
            <button style={{ ...S.guardarBtn, background: '#F0F4F0', color: '#7A8F89' }} onClick={onCerrar}>Volver</button>
            <button style={{ ...S.guardarBtn, background: '#c62828' }} onClick={confirmar}>✕ Confirmar cancelación</button>
          </div>
        </div>
      </div>
    </div>
  );
}

function ModalPedido({ pedido, modo, onCerrar, onActualizar, onCancelar }) {
  const [paqueteria,   setPaqueteria]   = useState(pedido.paqueteria || '');
  const [guia,         setGuia]         = useState(pedido.numero_guia || '');
  const [nota,         setNota]         = useState(pedido.nota_interna || '');
  const [guardando,    setGuardando]    = useState(false);
  const [editandoGuia, setEditandoGuia] = useState(false);
  const [confirmWA,    setConfirmWA]    = useState(null);

  const esEnvio   = pedido.tipo_entrega === 'envio';
  const tieneGuia = pedido.numero_guia && pedido.numero_guia.length > 0;
  const esEnviar  = modo === 'enviar';
  const domicilio = parseJSON(pedido.domicilio);
  const historial = parseJSON(pedido.historial);
  const paqNombre = PAQUETERIAS[pedido.paqueteria] || pedido.paqueteria || '';

  async function guardar() {
    // Validar campos obligatorios en modo enviar
    if (esEnviar && esEnvio) {
      if (!paqueteria) { alert('Selecciona la paquetería'); return; }
      if (!guia.trim()) { alert('Escribe el número de guía'); return; }
    }
    setGuardando(true);
    const nuevoHist = [...historial];
    let nuevoEstado = pedido.estado;
    let waMsg = '';
    let hayCambios = false;

    if (esEnvio && guia && guia !== pedido.numero_guia) {
      if (!paqueteria) { alert('Selecciona la paquetería'); setGuardando(false); return; }
      const paqLabel = PAQUETERIAS[paqueteria] || paqueteria;
      const trackUrl = (TRACKING[paqueteria] || '') + guia;
      nuevoEstado = 'enviado';
      nuevoHist.push({ texto: `Guía: ${guia} (${paqLabel})`, fecha: new Date().toLocaleString('es-MX'), interna: false });
      waMsg = `Tu pedido #${pedido.numero} va en camino 🚚\nPaquetería: ${paqLabel}\nGuía: ${guia}\n\nRastrear: ${trackUrl}`;
      hayCambios = true;
    }

    if (nota !== (pedido.nota_interna || '')) {
      nuevoHist.push({ texto: `Nota: ${nota}`, fecha: new Date().toLocaleString('es-MX'), interna: true });
    }

    await fetch(`${BASE_URL}/pedidos/${pedido.id}`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ estado: nuevoEstado, paqueteria, numero_guia: guia, nota_interna: nota, historial: nuevoHist }),
    });

    setGuardando(false);
    onActualizar();
    onCerrar();
    if (hayCambios && waMsg) setConfirmWA({ nombre: pedido.cliente_nombre, tel: pedido.cliente_telefono, msg: waMsg });
  }

  function reenviarGuia() {
    const paqLabel = PAQUETERIAS[pedido.paqueteria] || pedido.paqueteria;
    const trackUrl = (TRACKING[pedido.paqueteria] || '') + pedido.numero_guia;
    setConfirmWA({ nombre: pedido.cliente_nombre, tel: pedido.cliente_telefono,
      msg: `Tu pedido #${pedido.numero} va en camino 🚚\nPaquetería: ${paqLabel}\nGuía: ${pedido.numero_guia}\n\nRastrear: ${trackUrl}` });
  }

  if (confirmWA) return <ConfirmWA {...confirmWA} onCerrar={() => setConfirmWA(null)} />;

  return (
    <div style={S.overlay} onClick={e => e.target === e.currentTarget && onCerrar()}>
      <div style={S.modal}>
        <div style={S.handle} />
        <div style={S.modalHdr}>
          <span style={S.modalTitle}>{esEnviar ? '🚚 Enviar pedido' : '✏️ Editar pedido'} #{pedido.numero}</span>
          <button style={S.closeBtn} onClick={onCerrar}>✕</button>
        </div>
        <div style={S.modalBody}>

          <div style={S.msec}>
            <div style={S.mlbl}>Cliente</div>
            <div style={S.infoBox}>
              <div style={{ ...S.infoLinea, fontWeight: 700 }}>{pedido.cliente_nombre}</div>
              <div style={{ ...S.infoLinea, borderBottom: 'none' }}>{pedido.cliente_telefono}</div>
            </div>
          </div>

          <div style={S.msec}>
            <div style={S.mlbl}>Productos del pedido</div>
            <ItemsList items={pedido.items} />
          </div>

          <div style={S.msec}>
            <div style={S.mlbl}>{esEnvio ? 'Dirección de entrega' : 'Tipo de entrega'}</div>
            {esEnvio && domicilio && domicilio.calle ? (
              <div style={S.infoBox}>
                <div style={S.infoLinea}>{domicilio.nombre}</div>
                <div style={S.infoLinea}>{domicilio.calle}</div>
                <div style={S.infoLinea}>{domicilio.colonia}</div>
                <div style={S.infoLinea}>CP {domicilio.cp}</div>
                <div style={S.infoLinea}>{domicilio.ciudad}</div>
                <div style={{ ...S.infoLinea, borderBottom: 'none' }}>{domicilio.pais}</div>
              </div>
            ) : (
              <div style={{ ...S.infoBox, background: '#f3e5f5' }}>
                <div style={{ ...S.infoLinea, color: '#6a1b9a', fontWeight: 700, borderColor: '#e1bee7' }}>{pedido.cliente_nombre}</div>
                <div style={{ ...S.infoLinea, color: '#6a1b9a', borderBottom: 'none' }}>🏪 Recoger en tienda</div>
              </div>
            )}
          </div>

          {esEnvio && (
            <div style={S.msec}>
              {tieneGuia && !editandoGuia && !esEnviar ? (
                <>
                  <div style={S.mlbl}>Envío</div>
                  <div style={S.guiaActual}>
                    <div>
                      <div style={{ fontSize: 13, fontWeight: 700, color: '#0D1F1A' }}>{paqNombre} — {pedido.numero_guia}</div>
                      <div style={{ fontSize: 11, color: '#7A8F89', marginTop: 2 }}>Número de guía</div>
                    </div>
                    <button style={S.editGuiaBtn} onClick={() => setEditandoGuia(true)}>✏️ Editar</button>
                  </div>
                  <button style={S.reenviarBtn} onClick={reenviarGuia}>📲 Reenviar guía al cliente</button>
                </>
              ) : (
                <>
                  <div style={S.mlbl}>{esEnviar ? 'Captura la guía de envío' : 'Paquetería y guía'}</div>
                  {esEnviar && <div style={S.envioBanner}>🚚 Al guardar la guía el pedido cambia a Enviado automáticamente</div>}
                  <select style={S.select} value={paqueteria} onChange={e => setPaqueteria(e.target.value)}>
                    <option value="">Selecciona paquetería...</option>
                    {Object.entries(PAQUETERIAS).map(([v, l]) => <option key={v} value={v}>{l}</option>)}
                  </select>
                  <input style={S.input} placeholder="Número de guía" value={guia} onChange={e => setGuia(e.target.value)} />
                  {editandoGuia && <button style={S.cancelarEditBtn} onClick={() => setEditandoGuia(false)}>Cancelar edición</button>}
                </>
              )}
            </div>
          )}

          {!esEnviar && (
            <div style={S.msec}>
              <div style={S.mlbl}>Nota interna</div>
              <textarea style={S.textarea} placeholder="Solo visible para ti y tus empleados..." value={nota} onChange={e => setNota(e.target.value)} />
              <div style={S.notaHint}>🔒 No se envía al cliente</div>
            </div>
          )}

          {!esEnviar && !['cancelado', 'entregado', 'recogido'].includes(pedido.estado) && (
            <div style={S.zonaCritica}>
              <div style={S.zonaTitulo}>⚠️ Acciones críticas</div>
              {['pendiente', 'confirmado', 'espera'].includes(pedido.estado) && (
                <button style={S.btnRevisionModal} onClick={onCerrar}>🔍 Poner en revisión</button>
              )}
              <button style={S.btnCancelarModal} onClick={onCancelar}>✕ Cancelar pedido</button>
            </div>
          )}

          <button style={{ ...S.guardarBtn, opacity: guardando ? 0.7 : 1 }} onClick={guardar} disabled={guardando}>
            {guardando ? '⏳ Guardando...' : esEnviar ? '🚚 Guardar y marcar como Enviado' : '✓ Guardar cambios'}
          </button>

          <div style={{ ...S.msec, marginTop: 16 }}>
            <div style={S.mlbl}>Historial</div>
            <div style={S.histWrap}>
              {historial.map((h, i) => (
                <div key={i} style={S.histItem}>
                  <div style={{ ...S.histDot, background: h.interna ? '#bdbdbd' : '#25D366' }} />
                  <div>
                    <div style={{ ...S.histTxt, fontStyle: h.interna ? 'italic' : 'normal', color: h.interna ? '#7A8F89' : '#0D1F1A' }}>
                      {h.interna ? '🔒 ' : ''}{h.texto}
                    </div>
                    <div style={S.histFecha}>{h.fecha}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>

        </div>
      </div>
    </div>
  );
}

function Pedidos({ filtroInicial = 'todos' }) {
  const [pedidos,          setPedidos]          = useState([]);
  const [cargando,         setCargando]         = useState(true);
  const [filtro,           setFiltro]           = useState(filtroInicial);
  const [modalPedido,      setModalPedido]      = useState(null);
  const [modoModal,        setModoModal]        = useState('editar');
  const [modalCancelacion, setModalCancelacion] = useState(null);
  const [confirmWA,        setConfirmWA]        = useState(null);

  const cargarPedidos = useCallback(async () => {
    setCargando(true);
    try {
      const res  = await fetch(`${BASE_URL}/pedidos`);
      const data = await res.json();
      setPedidos(Array.isArray(data) ? data : []);
    } catch { setPedidos([]); }
    setCargando(false);
  }, []);

  useEffect(() => { cargarPedidos(); }, [cargarPedidos]);

  async function cambiarEstado(pedido, nuevoEstado, waMsg) {
    const historial = parseJSON(pedido.historial);
    const textos = { confirmado:'Confirmado por vendedor', espera:'Listo — en espera del cliente', recogido:'Cliente recogió el pedido', revision:'Puesto en revisión', cancelado:'Cancelado' };
    historial.push({ texto: textos[nuevoEstado] || nuevoEstado, fecha: new Date().toLocaleString('es-MX'), interna: false });
    await fetch(`${BASE_URL}/pedidos/${pedido.id}`, { method:'PUT', headers:{'Content-Type':'application/json'}, body: JSON.stringify({ estado: nuevoEstado, historial }) });
    cargarPedidos();
    if (waMsg) setConfirmWA({ nombre: pedido.cliente_nombre, tel: pedido.cliente_telefono, msg: waMsg });
  }

  async function cancelarPedido(pedido, motivo, comentarios) {
    const historial = parseJSON(pedido.historial);
    historial.push({ texto: `Cancelado — ${motivo}${comentarios ? ': ' + comentarios : ''}`, fecha: new Date().toLocaleString('es-MX'), interna: false });
    await fetch(`${BASE_URL}/pedidos/${pedido.id}`, { method:'PUT', headers:{'Content-Type':'application/json'}, body: JSON.stringify({ estado:'cancelado', historial }) });
    setModalCancelacion(null);
    cargarPedidos();
    setConfirmWA({ nombre: pedido.cliente_nombre, tel: pedido.cliente_telefono,
      msg: `Lamentamos informarte que tu pedido #${pedido.numero} fue cancelado.\nMotivo: ${motivo}.\nContáctanos para cualquier duda.` });
  }

  async function salirRevision(pedido) {
    const estadoDestino = pedido.tipo_entrega === 'envio' ? 'pendiente' : 'confirmado';
    const historial = parseJSON(pedido.historial);
    historial.push({ texto: `Resuelto — regresado a ${estadoDestino === 'pendiente' ? 'Pendiente' : 'Confirmado'}`, fecha: new Date().toLocaleString('es-MX'), interna: false });
    await fetch(`${BASE_URL}/pedidos/${pedido.id}`, { method:'PUT', headers:{'Content-Type':'application/json'}, body: JSON.stringify({ estado: estadoDestino, historial }) });
    cargarPedidos();
    setConfirmWA({ nombre: pedido.cliente_nombre, tel: pedido.cliente_telefono,
      msg: `Buenas noticias ${(pedido.cliente_nombre||'').split(' ')[0]} ✅\nHemos resuelto el inconveniente con tu pedido #${pedido.numero}.\n${estadoDestino==='pendiente'?'En breve te confirmamos.':'Ya está listo para recoger pronto.'}` });
  }

  function abrirEditar(p)      { setModalPedido(p); setModoModal('editar'); }
  function abrirEnviar(p)      { setModalPedido(p); setModoModal('enviar'); }
  function abrirCancelacion(p) { setModalPedido(null); setModalCancelacion(p); }
  const wa   = (p, txt) => setConfirmWA({ nombre: p.cliente_nombre, tel: p.cliente_telefono, msg: txt });
  const n0   = p => (p.cliente_nombre||'').split(' ')[0];

  const filtrados  = filtro==='todos' ? pedidos : pedidos.filter(p => p.estado===filtro);
  const pendientes = pedidos.filter(p => p.estado==='pendiente').length;
  const enCamino   = pedidos.filter(p => p.estado==='enviado').length;
  const ventasHoy  = pedidos.reduce((a,p) => a + parseFloat(p.total||0), 0);

  if (cargando) return <div style={S.loading}>Cargando pedidos...</div>;

  return (
    <div style={S.container}>
      <div style={S.summary}>
        <div style={S.sumCard}><div style={S.sumVal}>{pedidos.length}</div><div style={S.sumLbl}>Pedidos hoy</div></div>
        <div style={S.sumCard}><div style={{...S.sumVal,color:'#e67e22'}}>{pendientes}</div><div style={S.sumLbl}>Pendientes</div></div>
        <div style={S.sumCard}><div style={{...S.sumVal,color:'#2e7d32'}}>${ventasHoy.toLocaleString('es-MX',{minimumFractionDigits:2})}</div><div style={S.sumLbl}>Ventas hoy</div></div>
        <div style={S.sumCard}><div style={{...S.sumVal,color:'#1565c0'}}>{enCamino}</div><div style={S.sumLbl}>En camino</div></div>
      </div>

      <div style={S.filters} className="filters-hide-scroll">
        {FILTROS.map(f => (
          <button key={f} style={{...S.fbtn,...(filtro===f?S.fbtnActive:{})}} onClick={() => setFiltro(f)}>
            {f==='todos' ? 'Todos' : PILL[f]?.texto||f}
          </button>
        ))}
      </div>

      {filtrados.length===0 && <div style={S.empty}><div style={{fontSize:40,marginBottom:10}}>📦</div><div style={{fontSize:14,color:'#7A8F89'}}>Sin pedidos</div></div>}

      {filtrados.map(p => {
        const pill    = PILL[p.estado]||PILL.pendiente;
        const esEnvio = p.tipo_entrega==='envio';
        return (
          <div key={p.id} style={S.card}>
            {p.estado==='revision' && <div style={S.revisionBanner}>🔍 En revisión — contacta al cliente para resolver</div>}
            <div style={S.cardHdr}>
              <div style={S.cardNum}>#{p.numero}</div>
              <span style={{...S.pill,background:pill.bg,color:pill.color}}>{pill.texto}</span>
              <span style={S.cardPago}>{p.forma_pago}</span>
            </div>
            <div style={S.cardBody}>
              <div style={S.clienteRow}>
                <div style={S.avatar}>{iniciales(p.cliente_nombre)}</div>
                <div><div style={S.clienteNombre}>{p.cliente_nombre}</div><div style={S.clienteTel}>{p.cliente_telefono}</div></div>
              </div>
              <ItemsList items={p.items} />
              <div style={{marginBottom:8}}>
                <span style={{...S.entregaBadge,...(esEnvio?S.badgeEnvio:S.badgeTienda)}}>
                  {esEnvio?'🚚 Envío a domicilio':'🏪 Recoger en tienda'}
                </span>
              </div>
              <div style={S.totalRow}>
                <span style={S.totalLbl}>Total</span>
                <span style={S.totalVal}>${parseFloat(p.total||0).toLocaleString('es-MX',{minimumFractionDigits:2})}</span>
              </div>
            </div>
            <div style={S.acciones}>
              {p.estado==='revision' && <>
                <button style={{...S.btn,...S.btnVerde}} onClick={() => salirRevision(p)}>✓ Resolver</button>
                <button style={{...S.btn,...S.btnRojo}} onClick={() => abrirCancelacion(p)}>✕ Cancelar</button>
                <button style={{...S.btn,...S.btnWA}} onClick={() => wa(p,`Hola ${n0(p)}, ¿resolviste el inconveniente con tu pedido #${p.numero}?`)}>💬</button>
              </>}
              {p.estado==='pendiente' && <>
                <button style={{...S.btn,...S.btnVerde}} onClick={() => cambiarEstado(p,'confirmado',`Hola ${n0(p)} 👋\nTu pedido #${p.numero} fue confirmado ✅\nEstamos preparándolo.`)}>✓ Confirmar</button>
                <button style={{...S.btn,...S.btnAmarillo}} onClick={() => cambiarEstado(p,'revision',`Hola ${n0(p)} 🔍\nEstamos revisando tu pedido #${p.numero} y te contactaremos en breve.`)}>🔍 Revisar</button>
                <button style={S.btn} onClick={() => abrirEditar(p)}>✏️ Editar</button>
                <button style={{...S.btn,...S.btnWA}} onClick={() => wa(p,`Hola ${n0(p)}, ¿en qué te podemos ayudar con tu pedido #${p.numero}?`)}>💬</button>
              </>}
              {p.estado==='confirmado' && p.tipo_entrega==='envio' && <>
                <button style={{...S.btn,...S.btnAzul}} onClick={() => abrirEnviar(p)}>🚚 Enviar</button>
                <button style={{...S.btn,...S.btnAmarillo}} onClick={() => cambiarEstado(p,'revision',`Hola ${n0(p)} 🔍\nEstamos revisando tu pedido #${p.numero} y te contactaremos en breve.`)}>🔍 Revisar</button>
                <button style={S.btn} onClick={() => abrirEditar(p)}>✏️ Editar</button>
                <button style={{...S.btn,...S.btnWA}} onClick={() => wa(p,`Hola ${n0(p)}, ¿en qué te podemos ayudar con tu pedido #${p.numero}?`)}>💬</button>
              </>}
              {p.estado==='confirmado' && p.tipo_entrega==='tienda' && <>
                <button style={{...S.btn,...S.btnMorado}} onClick={() => cambiarEstado(p,'espera',`Hola ${n0(p)} 🏪\nTu pedido #${p.numero} está listo para recoger.\nPuedes pasar cuando gustes.`)}>📦 Listo</button>
                <button style={{...S.btn,...S.btnAmarillo}} onClick={() => cambiarEstado(p,'revision',`Hola ${n0(p)} 🔍\nEstamos revisando tu pedido #${p.numero} y te contactaremos en breve.`)}>🔍 Revisar</button>
                <button style={S.btn} onClick={() => abrirEditar(p)}>✏️ Editar</button>
                <button style={{...S.btn,...S.btnWA}} onClick={() => wa(p,`Hola ${n0(p)}, ¿en qué te podemos ayudar con tu pedido #${p.numero}?`)}>💬</button>
              </>}
              {p.estado==='espera' && <>
                <button style={{...S.btn,...S.btnNaranja}} onClick={() => cambiarEstado(p,'recogido',`¡Gracias por tu compra ${n0(p)}! 🎉\nEsperamos verte pronto.`)}>✓ Recogido</button>
                <button style={S.btn} onClick={() => abrirEditar(p)}>✏️ Editar</button>
                <button style={{...S.btn,...S.btnWA}} onClick={() => wa(p,`Hola ${n0(p)}, ¿en qué te podemos ayudar con tu pedido #${p.numero}?`)}>💬</button>
              </>}
              {p.estado==='enviado' && <>
                <button style={S.btn} onClick={() => abrirEditar(p)}>✏️ Editar</button>
                <button style={{...S.btn,...S.btnWA}} onClick={() => wa(p,`Hola ${n0(p)}, ¿en qué te podemos ayudar con tu pedido #${p.numero}?`)}>💬</button>
              </>}
              {['recogido','entregado','cancelado'].includes(p.estado) && <>
                <button style={S.btn} onClick={() => abrirEditar(p)}>✏️ Editar</button>
                <button style={{...S.btn,...S.btnWA}} onClick={() => wa(p,`Hola ${n0(p)}, ¿en qué te podemos ayudar con tu pedido #${p.numero}?`)}>💬</button>
              </>}
            </div>
          </div>
        );
      })}

      {modalPedido && (
        <ModalPedido
          pedido={modalPedido}
          modo={modoModal}
          onCerrar={() => setModalPedido(null)}
          onActualizar={cargarPedidos}
          onCancelar={() => abrirCancelacion(modalPedido)}
        />
      )}

      {modalCancelacion && (
        <ModalCancelacion
          pedido={modalCancelacion}
          onCerrar={() => setModalCancelacion(null)}
          onConfirmar={(motivo, comentarios) => cancelarPedido(modalCancelacion, motivo, comentarios)}
        />
      )}

      {confirmWA && <ConfirmWA {...confirmWA} onCerrar={() => setConfirmWA(null)} />}
    </div>
  );
}

const S = {
  container:       { padding:16, paddingBottom:90 },
  loading:         { padding:40, textAlign:'center', color:'#7A8F89' },
  summary:         { display:'grid', gridTemplateColumns:'1fr 1fr', gap:8, marginBottom:12 },
  sumCard:         { background:'white', borderRadius:12, padding:'10px 12px', border:'1px solid #E4EDE8' },
  sumVal:          { fontSize:20, fontWeight:800, color:'#0D1F1A' },
  sumLbl:          { fontSize:11, color:'#7A8F89', marginTop:2 },
  filters:         { display:'flex', gap:6, marginBottom:12, overflowX:'auto', paddingBottom:4, scrollbarWidth:'none', msOverflowStyle:'none' },
  fbtn:            { border:'1px solid #E4EDE8', borderRadius:20, padding:'5px 12px', fontSize:11, background:'white', color:'#7A8F89', cursor:'pointer', whiteSpace:'nowrap', fontFamily:'inherit' },
  fbtnActive:      { background:'#075E54', color:'white', borderColor:'#075E54' },
  empty:           { textAlign:'center', padding:'40px 20px' },
  card:            { background:'white', borderRadius:16, border:'1px solid #E4EDE8', marginBottom:10, overflow:'hidden' },
  revisionBanner:  { background:'#fce4ec', borderBottom:'1px solid #f8bbd0', padding:'7px 12px', fontSize:11, color:'#880e4f' },
  cardHdr:         { display:'flex', alignItems:'center', gap:8, padding:'10px 12px', borderBottom:'1px solid #E4EDE8' },
  cardNum:         { fontSize:13, fontWeight:700, color:'#0D1F1A', flex:1 },
  pill:            { fontSize:10, fontWeight:700, padding:'3px 10px', borderRadius:20, whiteSpace:'nowrap' },
  cardPago:        { fontSize:11, color:'#7A8F89' },
  cardBody:        { padding:'10px 12px' },
  clienteRow:      { display:'flex', alignItems:'center', gap:8, marginBottom:10 },
  avatar:          { width:32, height:32, borderRadius:'50%', background:'#E3F2FD', display:'flex', alignItems:'center', justifyContent:'center', fontSize:12, fontWeight:700, color:'#1565c0', flexShrink:0 },
  clienteNombre:   { fontSize:13, fontWeight:700, color:'#0D1F1A' },
  clienteTel:      { fontSize:11, color:'#7A8F89' },
  itemsWrap:       { border:'1px solid #E4EDE8', borderRadius:12, overflow:'hidden', marginBottom:8 },
  itemRow:         { display:'flex', alignItems:'center', gap:10, padding:'8px 10px' },
  itemEmoji:       { width:40, height:40, borderRadius:8, background:'#F0F4F0', display:'flex', alignItems:'center', justifyContent:'center', fontSize:22, flexShrink:0 },
  itemInfo:        { flex:1 },
  itemNombre:      { fontSize:11, color:'#7A8F89', marginBottom:3 },
  varRow:          { display:'flex', gap:5, alignItems:'center', flexWrap:'wrap' },
  colorChip:       { background:'#F0F4F0', borderRadius:20, padding:'2px 10px', fontSize:12, fontWeight:700, color:'#0D1F1A', border:'1px solid #E4EDE8' },
  tallaChip:       { background:'#e3f2fd', borderRadius:20, padding:'2px 10px', fontSize:13, fontWeight:700, color:'#1565c0', border:'1px solid #90caf9' },
  qtyWrap:         { display:'flex', flexDirection:'column', alignItems:'center', gap:1, flexShrink:0 },
  qtyLbl:          { fontSize:9, fontWeight:700, color:'#7A8F89', textTransform:'uppercase', letterSpacing:0.4 },
  qty:             { fontSize:18, fontWeight:800, color:'#c62828', background:'#ffebee', borderRadius:6, padding:'2px 10px', minWidth:36, textAlign:'center' },
  emptyItems:      { fontSize:12, color:'#7A8F89', padding:10 },
  entregaBadge:    { display:'inline-flex', alignItems:'center', gap:5, fontSize:11, padding:'3px 10px', borderRadius:20 },
  badgeEnvio:      { background:'#e3f2fd', color:'#1565c0' },
  badgeTienda:     { background:'#f3e5f5', color:'#6a1b9a' },
  totalRow:        { display:'flex', justifyContent:'space-between', alignItems:'center', paddingTop:8, borderTop:'1px solid #E4EDE8' },
  totalLbl:        { fontSize:12, color:'#7A8F89' },
  totalVal:        { fontSize:16, fontWeight:800, color:'#0D1F1A' },
  acciones:        { display:'flex', gap:6, padding:'8px 12px', borderTop:'1px solid #E4EDE8', background:'#F0F4F0', flexWrap:'wrap' },
  btn:             { flex:1, padding:'7px 6px', borderRadius:10, border:'1px solid #E4EDE8', background:'white', fontSize:11, fontWeight:700, color:'#7A8F89', cursor:'pointer', textAlign:'center', minWidth:55, fontFamily:'inherit' },
  btnVerde:        { background:'#25D366', color:'white', borderColor:'#25D366' },
  btnAzul:         { background:'#1565c0', color:'white', borderColor:'#1565c0' },
  btnMorado:       { background:'#7b1fa2', color:'white', borderColor:'#7b1fa2' },
  btnNaranja:      { background:'#e65100', color:'white', borderColor:'#e65100' },
  btnAmarillo:     { background:'#f57f17', color:'white', borderColor:'#f57f17' },
  btnRojo:         { background:'#c62828', color:'white', borderColor:'#c62828' },
  btnWA:           { background:'#075E54', color:'white', borderColor:'#075E54' },
  overlay:         { position:'fixed', inset:0, background:'rgba(0,0,0,0.5)', zIndex:200, display:'flex', alignItems:'flex-end', justifyContent:'center' },
  modal:           { background:'white', borderRadius:'24px 24px 0 0', width:'100%', maxWidth:430, maxHeight:'92vh', overflowY:'auto' },
  handle:          { width:40, height:4, background:'#e0e0e0', borderRadius:2, margin:'12px auto 0' },
  modalHdr:        { padding:'14px 20px 12px', display:'flex', alignItems:'center', justifyContent:'space-between', borderBottom:'1px solid #E4EDE8' },
  modalTitle:      { fontSize:15, fontWeight:800, color:'#0D1F1A' },
  closeBtn:        { width:32, height:32, background:'#F0F4F0', borderRadius:'50%', border:'none', cursor:'pointer', fontSize:16, color:'#7A8F89' },
  modalBody:       { padding:20 },
  msec:            { marginBottom:16 },
  mlbl:            { display:'block', fontSize:11, fontWeight:700, color:'#7A8F89', textTransform:'uppercase', letterSpacing:0.5, marginBottom:6 },
  infoBox:         { background:'#F0F4F0', borderRadius:12, padding:'10px 14px' },
  infoLinea:       { fontSize:13, color:'#0D1F1A', padding:'4px 0', borderBottom:'1px solid #E4EDE8' },
  guiaActual:      { background:'#F0F4F0', borderRadius:12, padding:'10px 14px', display:'flex', alignItems:'center', justifyContent:'space-between' },
  editGuiaBtn:     { fontSize:11, color:'#128C7E', background:'none', border:'1px solid #128C7E', borderRadius:20, padding:'4px 10px', cursor:'pointer', fontFamily:'inherit' },
  reenviarBtn:     { width:'100%', marginTop:6, padding:10, borderRadius:12, border:'none', background:'#25D366', color:'white', fontSize:12, fontWeight:700, cursor:'pointer', fontFamily:'inherit' },
  envioBanner:     { background:'#e3f2fd', borderRadius:10, padding:'8px 12px', fontSize:12, color:'#1565c0', marginBottom:8 },
  select:          { width:'100%', background:'#F0F4F0', border:'1.5px solid #E4EDE8', borderRadius:12, padding:'10px 14px', fontSize:14, color:'#0D1F1A', outline:'none', fontFamily:'inherit', marginBottom:8, boxSizing:'border-box' },
  input:           { width:'100%', background:'#F0F4F0', border:'1.5px solid #E4EDE8', borderRadius:12, padding:'10px 14px', fontSize:14, color:'#0D1F1A', outline:'none', fontFamily:'inherit', boxSizing:'border-box' },
  cancelarEditBtn: { marginTop:6, fontSize:11, color:'#7A8F89', background:'none', border:'none', cursor:'pointer', fontFamily:'inherit' },
  textarea:        { width:'100%', background:'#F0F4F0', border:'1.5px solid #E4EDE8', borderRadius:12, padding:'10px 14px', fontSize:14, color:'#0D1F1A', outline:'none', fontFamily:'inherit', height:72, resize:'none', boxSizing:'border-box' },
  notaHint:        { fontSize:11, color:'#7A8F89', marginTop:4 },
  avisoRojo:       { background:'#fff5f5', border:'1px solid #ffcdd2', borderRadius:12, padding:'10px 12px', fontSize:12, color:'#c62828', marginBottom:14, lineHeight:1.5 },
  zonaCritica:     { border:'1px solid #ffcdd2', borderRadius:12, padding:'10px 12px', background:'#fff5f5', marginBottom:14 },
  zonaTitulo:      { fontSize:11, fontWeight:700, color:'#c62828', marginBottom:8 },
  btnRevisionModal:{ width:'100%', marginBottom:6, padding:9, borderRadius:10, border:'1px solid #f57f17', background:'#fff8e1', color:'#f57f17', fontSize:12, fontWeight:700, cursor:'pointer', fontFamily:'inherit' },
  btnCancelarModal:{ width:'100%', padding:9, borderRadius:10, border:'1px solid #ffcdd2', background:'#ffebee', color:'#c62828', fontSize:12, fontWeight:700, cursor:'pointer', fontFamily:'inherit' },
  guardarBtn:      { width:'100%', background:'linear-gradient(135deg,#25D366,#128C7E)', color:'white', border:'none', borderRadius:16, padding:14, fontSize:15, fontWeight:700, cursor:'pointer', marginTop:4 },
  histWrap:        { paddingLeft:16, borderLeft:'2px solid #E4EDE8' },
  histItem:        { position:'relative', marginBottom:10 },
  histDot:         { position:'absolute', left:-21, top:4, width:8, height:8, borderRadius:'50%' },
  histTxt:         { fontSize:12 },
  histFecha:       { fontSize:10, color:'#7A8F89', marginTop:1 },
  confirmOverlay:  { position:'fixed', inset:0, background:'rgba(0,0,0,0.6)', zIndex:300, display:'flex', alignItems:'center', justifyContent:'center', padding:16 },
  confirmCard:     { background:'white', borderRadius:16, padding:20, width:'100%', maxWidth:340 },
  confirmTitle:    { fontSize:15, fontWeight:800, color:'#0D1F1A', marginBottom:8 },
  confirmMsg:      { fontSize:12, color:'#7A8F89', marginBottom:16, lineHeight:1.6, background:'#F0F4F0', padding:'10px 12px', borderRadius:10, whiteSpace:'pre-line' },
  confirmBtns:     { display:'flex', gap:8 },
  confirmNo:       { flex:1, padding:10, borderRadius:10, border:'1px solid #E4EDE8', background:'#F0F4F0', color:'#7A8F89', fontSize:13, cursor:'pointer', fontFamily:'inherit' },
  confirmSi:       { flex:1, padding:10, borderRadius:10, border:'none', background:'#25D366', color:'white', fontSize:13, fontWeight:700, cursor:'pointer', fontFamily:'inherit' },
};

export default Pedidos;